export default __webpack_public_path__ + "static/media/griffin.aaaa6e9c.png";